import { titleCase } from '~app/shared/functions/utils/utils.function';

export class CrewPhysique {
  private readonly data: {
    hairColor: string;
    eyeColor: string;
    height: string;
    weight: string;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get hairColor(): string {
    try {
      return titleCase(this.data.hairColor);
    } catch (error) {
      return undefined;
    }
  }

  public get eyeColor(): string {
    try {
      return titleCase(this.data.eyeColor);
    } catch (error) {
      return undefined;
    }
  }

  public get height(): string {
    try {
      return this.data.height;
    } catch (error) {
      return undefined;
    }
  }

  public get weight(): string {
    try {
      return this.data.weight;
    } catch (error) {
      return undefined;
    }
  }
}
